import { FabricObject, Group, StaticCanvas } from 'fabric';

// Gets the child bounds inside the group.
const childLocalBbox = (child: FabricObject) => {
  const width = (child.width ?? 0) * (child.scaleX ?? 1);
  const height = (child.height ?? 0) * (child.scaleY ?? 1);
  const centerX = child.left ?? 0;
  const centerY = child.top ?? 0;

  return {
    left: centerX - width / 2,
    right: centerX + width / 2,
    top: centerY - height / 2,
    bottom: centerY + height / 2
  };
};

/** Fits the group bounds to its children. */
function recenterChain(group: Group): void {
  const children = group.getObjects();
  if (children.length === 0) return;

  let minLeft = Infinity;
  let maxRight = -Infinity;
  let minTop = Infinity;
  let maxBottom = -Infinity;

  for (const child of children) {
    const bounds = childLocalBbox(child);

    if (bounds.left < minLeft) minLeft = bounds.left;
    if (bounds.right > maxRight) maxRight = bounds.right;
    if (bounds.top < minTop) minTop = bounds.top;
    if (bounds.bottom > maxBottom) maxBottom = bounds.bottom;
  }

  const centerX = (minLeft + maxRight) / 2;
  const centerY = (minTop + maxBottom) / 2;

  for (const child of children) {
    child.set({
      left: (child.left ?? 0) - centerX,
      top: (child.top ?? 0) - centerY
    });

    child.setCoords();
  }

  group.set({
    width: maxRight - minLeft,
    height: maxBottom - minTop
  });

  group.setCoords();
  group.dirty = true;
}

/** Recenters all attached pill groups. */
export function applyAllChainRecenter(canvas: StaticCanvas): void {
  for (const obj of canvas.getObjects()) {
    if (!(obj instanceof Group)) continue;

    const hasChain = obj.getObjects().some(child => Boolean((child as FabricObject).attachTo));

    if (!hasChain) continue;

    recenterChain(obj);
  }
}
